import { RewardModel } from '@shared/types';

import { DailyRewardFormValues } from '../DailyRewardForm';

import { DailyRewardModel } from 'v2/types/DailyRewardModel';

export const getDailyRewardEditFormInitialValues = (
  dailyReward: DailyRewardModel,
  rewards: RewardModel[]
): DailyRewardFormValues => {
  const { day, description, allowedUserRoles } = dailyReward;

  return { day, description, allowedUserRoles, rewards };
};
